/* ============================================
   LIVORNO LANDING PAGE — INTERACTIONS
   ============================================ */

(function() {
  'use strict';

  // Only run if we're on the Livorno page
  if (!document.querySelector('.livorno-page')) return;

  /* CUSTOM CURSOR */
  function initCursor() {
    if (window.matchMedia('(pointer: coarse)').matches) return;

    const cursor = document.createElement('div');
    cursor.className = 'lv-cursor';
    const trail = document.createElement('div');
    trail.className = 'lv-cursor-trail';
    document.body.appendChild(cursor);
    document.body.appendChild(trail);

    let mouseX = 0, mouseY = 0;
    let trailX = 0, trailY = 0;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
    });

    function animateTrail() {
      trailX += (mouseX - trailX) * 0.15;
      trailY += (mouseY - trailY) * 0.15;
      trail.style.transform = `translate(${trailX}px, ${trailY}px) translate(-50%, -50%)`;
      requestAnimationFrame(animateTrail);
    }
    animateTrail();

    document.querySelectorAll('.livorno-page a, .livorno-page button, .livorno-page summary, .lv-detail-card, .lv-persona, .lv-how-step, .lv-stat-card, .lv-review, .lv-guarantee').forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('hover'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('hover'));
    });
  }

  /* HERO PARALLAX */
  function initHeroParallax() {
    const hero = document.querySelector('.lv-hero');
    const glow1 = document.querySelector('.lv-hero-glow.left');
    const glow2 = document.querySelector('.lv-hero-glow.right');
    if (!hero || !glow1 || !glow2) return;

    hero.addEventListener('mousemove', (e) => {
      const rect = hero.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      glow1.style.transform = `translate(${x * 60}px, ${y * 60}px)`;
      glow2.style.transform = `translate(${x * -60}px, ${y * -60}px)`;
    });
  }

  /* COUNTERS */
  function initCounters() {
    const counters = document.querySelectorAll('.lv-counter');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('counted')) {
          const target = parseInt(entry.target.dataset.target);
          const duration = 1600;
          const start = performance.now();
          const animate = (now) => {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            entry.target.textContent = Math.floor(target * eased);
            if (progress < 1) requestAnimationFrame(animate);
            else entry.target.textContent = target;
          };
          requestAnimationFrame(animate);
          entry.target.classList.add('counted');
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(c => observer.observe(c));
  }

  /* REVEAL ON SCROLL */
  function initReveals() {
    const els = document.querySelectorAll('.lv-reveal, .lv-reveal-line');
    if (!els.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12 });

    els.forEach(el => observer.observe(el));
  }

  /* 7-SECOND SCROLL REVEAL */
  function initSevenSec() {
    const section = document.querySelector('.lv-seven');
    if (!section) return;

    const numEl = section.querySelector('.lv-seven-counter .number');
    const headline = section.querySelector('.lv-seven-headline');
    const sub = section.querySelector('.lv-seven-sub');
    const steps = section.querySelectorAll('.lv-seven-progress .step');

    const stages = JSON.parse(section.dataset.stages || '[]');
    if (!stages.length) return;

    window.addEventListener('scroll', () => {
      const rect = section.getBoundingClientRect();
      const total = section.offsetHeight - window.innerHeight;
      const progress = Math.max(0, Math.min(1, -rect.top / total));
      const sec = Math.round(progress * 7);
      if (numEl) numEl.textContent = sec;

      let currentStage = stages[0];
      for (const s of stages) { if (sec >= s.sec) currentStage = s; }
      if (headline && headline.dataset.last !== currentStage.h) {
        headline.innerHTML = currentStage.h;
        if (sub) sub.textContent = currentStage.s;
        headline.dataset.last = currentStage.h;
      }
      steps.forEach((step, i) => {
        if (i <= currentStage.step) step.classList.add('active');
        else step.classList.remove('active');
      });
    }, { passive: true });
  }

  /* 3D TILT */
  function initTilt() {
    document.querySelectorAll('.livorno-page [data-tilt]').forEach(card => {
      const inner = card.querySelector('.tilt-inner');
      if (!inner) return;
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        inner.style.transform = `perspective(1000px) rotateX(${-y * 6}deg) rotateY(${x * 6}deg)`;
      });
      card.addEventListener('mouseleave', () => {
        inner.style.transform = 'perspective(1000px) rotateX(0) rotateY(0)';
      });
    });
  }

  /* SIZE PICKER */
  function initPicker() {
    const picker = document.querySelector('.lv-picker');
    if (!picker) return;

    const tabs = picker.querySelectorAll('.lv-picker-tab');
    const bed = picker.querySelector('.lv-picker-bed');
    const bedLabel = picker.querySelector('.lv-picker-bed span');
    const display = picker.querySelector('.lv-picker-display');
    const sub = picker.querySelector('.lv-picker-sub');
    const ligopp = picker.querySelector('[data-spec="ligopp"]');
    const ingeklapt = picker.querySelector('[data-spec="ingeklapt"]');
    const dimW = picker.querySelector('.lv-picker-dim.w');
    const price = picker.querySelector('.lv-picker-price');
    const priceOld = picker.querySelector('.lv-picker-price-old');
    const ctaBtn = picker.querySelector('.lv-picker-cta');
    const cartForm = picker.querySelector('form[action*="/cart/add"]');
    const variantInput = picker.querySelector('input[name="id"]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        const size = tab.dataset.size;
        const variantId = tab.dataset.variantId;
        const variantPrice = tab.dataset.price;
        const variantCompare = tab.dataset.compare;
        const widthPct = tab.dataset.width;
        const sublabel = tab.dataset.sub;

        if (bed) bed.style.width = widthPct + '%';
        if (bedLabel) bedLabel.textContent = size + ' cm';
        if (display) display.innerHTML = size + ' <span class="x">×</span> 200';
        if (sub) sub.textContent = sublabel;
        if (ligopp) ligopp.textContent = size + ' × 193 cm';
        if (ingeklapt) ingeklapt.textContent = (parseInt(size) + 4) + ' × 46 × 111 cm';
        if (dimW) dimW.textContent = size + ' × 200 cm';
        if (price) price.textContent = variantPrice;
        if (priceOld) priceOld.textContent = variantCompare;
        if (variantInput) variantInput.value = variantId;

        // Flash effect
        picker.querySelectorAll('.lv-picker-spec').forEach(s => {
          s.classList.add('flash');
          setTimeout(() => s.classList.remove('flash'), 600);
        });
        if (price) {
          price.classList.add('flash');
          setTimeout(() => price.classList.remove('flash'), 600);
        }
      });
    });

    // AJAX add to cart (works with most Impact theme setups)
    if (cartForm) {
      cartForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const formData = new FormData(cartForm);
        ctaBtn.disabled = true;
        const originalText = ctaBtn.querySelector('span:first-child').textContent;
        ctaBtn.querySelector('span:first-child').textContent = 'Toevoegen...';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json' }
          });
          if (response.ok) {
            ctaBtn.querySelector('span:first-child').textContent = '✓ Toegevoegd!';
            // Trigger Impact theme cart refresh
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:open'));
            setTimeout(() => {
              ctaBtn.querySelector('span:first-child').textContent = originalText;
              ctaBtn.disabled = false;
            }, 2000);
          } else {
            // Fallback: redirect to cart
            window.location.href = '/cart';
          }
        } catch (err) {
          // Fallback: submit normally
          cartForm.submit();
        }
      });
    }
  }

  /* INIT ALL */
  function init() {
    initCursor();
    initHeroParallax();
    initCounters();
    initReveals();
    initSevenSec();
    initTilt();
    initPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
